<div class="menuVertical noPrint" [ngClass]=" {'menuVertical2':menuOpen === 1}">

    <div class="logoContainer">
        <a href="" routerLink="/">
            <div fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="1rem">
                <img [src]="logo" alt="logoPredictiva21" class="logoMenu">
                <span class="ft500 ft18 gray-1" fxShow="true" fxShow.lt-md="false" *ngIf="menuOpen===1">Predyc</span>
            </div>
        </a>
    </div>
    <div class="menuContainer">
        <div>
            <a href="" class="gray-7 ft12 ft500" routerLink="/admin/resumen" routerLinkActive="active-link">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <mat-icon class="linkIcon"> dashboard </mat-icon>
                    <span class="mgl05 gray-7 ft12 ft500" *ngIf="menuOpen===1" routerLink="/admin/resumen"
                        routerLinkActive="active-link"> Resumen</span>
                </div>
            </a>
        </div>

        <!-- Lista admins -->
        <div *ngIf="token == 'superadmin'" class="mgt10">
            <a href="" class="gray-7 ft12 ft500" routerLink="/admin/lista-admins">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <mat-icon class="linkIcon"> vpn_key </mat-icon>
                    <span class="mgl05 gray-7 ft12 ft500" *ngIf="menuOpen===1" routerLink="/admin/lista-admins"
                        routerLinkActive="active-link"> Admins</span>
                </div>
            </a>
        </div>

        <!-- cursos -->
        <div class="mgt10">
            <a href="" class="gray-7 ft12 ft500" routerLink="/admin/lista-cursos" routerLinkActive="active-link">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <mat-icon class="linkIcon"> laptop </mat-icon>
                    <span class="mgl05 gray-7 ft12 ft500" *ngIf="menuOpen===1" routerLink="/admin/lista-cursos"
                        routerLinkActive="active-link"> Cursos</span>
                </div>
            </a>
        </div>

        <!-- instructores -->
        <div class="mgt10">
            <a href="" class="gray-7 ft12 ft500" routerLink="/admin/lista-instructores" routerLinkActive="active-link">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <mat-icon class="linkIcon"> people </mat-icon>
                    <span class="mgl05 gray-7 ft12 ft500" *ngIf="menuOpen===1" routerLink="/admin/lista-instructores"
                        routerLinkActive="active-link"> Instructores</span>
                </div>
            </a>
        </div>

        <!-- empresas -->
        <div class="mgt10">
            <a href="" class="gray-7 ft12 ft500" routerLink="/admin/lista-empresas" routerLinkActive="active-link">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <mat-icon class="linkIcon"> business </mat-icon>
                    <span class="mgl05 gray-7 ft12 ft500" *ngIf="menuOpen===1" routerLink="/admin/lista-empresas"
                        routerLinkActive="active-link"> Empresas</span>
                </div>
            </a>
        </div>

        <!-- estudiantes -->
        <div class="mgt10">
            <a href="" class="gray-7 ft12 ft500" routerLink="/admin/lista-estudiantes" routerLinkActive="active-link">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <mat-icon class="linkIcon"> person </mat-icon>
                    <span class="mgl05 gray-7 ft12 ft500" *ngIf="menuOpen===1" routerLink="/admin/lista-estudiantes"
                        routerLinkActive="active-link"> Estudiantes</span>
                </div>
            </a>
        </div>

        <!-- empresas cliente -->
        <!-- <div class="mgt10">
            <a href="" class="gray-7 ft12 ft500" routerLink="/admin/lista-empresas-cliente" routerLinkActive="active-link" routerLinkActive="active-link">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <mat-icon class="linkIcon"> business_center </mat-icon>
                    <span class="mgl05 gray-7 ft12 ft500" *ngIf="menuOpen===1"  routerLink="/admin/lista-empresas-cliente" routerLinkActive="active-link"> Clientes</span>
                </div>
            </a>
        </div> -->

        <!-- ventas -->
        <div *ngIf="token == 'superadmin' || token == 'administrador' " class="mgt10">
            <a href="" class="gray-7 ft12 ft500" routerLink="/admin/ventas" routerLinkActive="active-link">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <mat-icon class="linkIcon"> attach_money </mat-icon>
                    <span class="mgl05 gray-7 ft12 ft500" *ngIf="menuOpen===1" routerLink="/admin/ventas"
                        routerLinkActive="active-link"> Ventas</span>
                </div>
            </a>
        </div>

        <div *ngIf="token == 'superadmin' || token == 'administrador' " class="mgt10">
            <a href="" class="gray-7 ft12 ft500" routerLink="/admin/venta-manual" routerLinkActive="active-link">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <mat-icon class="linkIcon"> touch_app </mat-icon>
                    <span class="mgl05 gray-7 ft12 ft500" *ngIf="menuOpen===1" routerLink="/admin/venta-manual"
                        routerLinkActive="active-link"> Venta manual</span>
                </div>
            </a>
        </div>

        <!-- pagos -->
        <div *ngIf="token == 'superadmin' || token == 'administrador' " class="mgt10">
            <a href="" class="gray-7 ft12 ft500" routerLink="/admin/pagos" routerLinkActive="active-link">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <mat-icon class="linkIcon"> credit_card</mat-icon>
                    <span class="mgl05 gray-7 ft12 ft500" *ngIf="menuOpen===1" routerLink="/admin/pagos"
                        routerLinkActive="active-link"> Pagos</span>
                </div>
            </a>
        </div>

        <!-- Chats -->
        <div *ngIf="token == 'superadmin' || token == 'administrador' " class="mgt10">
            <a href="" class="gray-7 ft12 ft500" routerLink="/admin/soporte-chat" routerLinkActive="active-link">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <mat-icon class="linkIcon"> message</mat-icon>
                    <span class="mgl05 gray-7 ft12 ft500" *ngIf="menuOpen===1" routerLink="/admin/pagos"
                        routerLinkActive="active-link"> Soporte</span>
                </div>
            </a>
        </div>

        <!-- Facturas -->
        <!-- <div *ngIf="token == 'superadmin' || token == 'administrador' " class="mgt10">
            <a href="" class="gray-7 ft12 ft500" routerLink="/est/detalle-factura" routerLinkActive="active-link">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <mat-icon class="linkIcon"> local_printshop</mat-icon>
                    <span class="mgl05 gray-7 ft12 ft500" *ngIf="menuOpen===1" routerLink="/admin/pagos"
                        routerLinkActive="active-link"> Facturas</span>
                </div>
            </a>
        </div> -->

        <!-- categorias -->
        <!-- <div class="mgt10">
            <a href="" class="gray-7 ft12 ft500" routerLink="/admin/lista-categorias" routerLinkActive="active-link">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <mat-icon class="linkIcon"> list </mat-icon>
                    <span class="mgl05 gray-7 ft12 ft500" *ngIf="menuOpen===1"  routerLink="/admin/lista-categorias" routerLinkActive="active-link"> Categorias</span>
                </div>
            </a>
        </div> -->

    </div>

    <div fxLayoutAlign="end">
        <mat-icon class="toggleIcon gray-7" (click)="menuOpen=1" *ngIf="menuOpen===0">
            keyboard_arrow_right
        </mat-icon>
        <mat-icon class="toggleIcon gray-8" (click)="menuOpen=0" *ngIf="menuOpen===1">
            keyboard_arrow_left
        </mat-icon>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center" class="bottomContainer">
        <img [src]="usuario.photoURL" alt="foto de perfil" class="avatar2" (click)="menuOpen=1">
        <a href="" class="mgl20 gray-8 ft10" *ngIf="menuOpen===1" (click)="signOut()">Cerrar Sesión</a>
    </div>


</div>